
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype1On as ObiMosfetNtype1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-1-on.js';
 
 
 

 
 export const ObiMosfetNtype1On = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-1-on',
   elementClass: ObiMosfetNtype1OnElement,
   events: {
     
   }
  });
 
 